import React from 'react';
import { Checkbox, FormControl, FormHelperText, InputLabel, ListItemText, MenuItem, Select } from '@mui/material';

export const DEFAULT_REMINDER_DAYS = [30, 7, 1, 0];
export const REMINDER_DAY_OPTIONS = [90, 60, 30, 14, 7, 3, 1, 0];
export const reminderSummary = days => {
  const selected = days ?? DEFAULT_REMINDER_DAYS;
  return selected.length ? [...selected].sort((a,b) => b-a).map(day => day === 0 ? 'On expiry date' : `${day} day${day === 1 ? '' : 's'} before`).join(', ') : 'Reminders off';
};

export default function ReminderDayOptions({ value, onChange, disabled = false }) {
  const labelId = React.useId();
  return <FormControl fullWidth size="small" disabled={disabled} sx={{ maxWidth: 560 }}>
    <InputLabel id={labelId} shrink>Remind me before</InputLabel>
    <Select multiple displayEmpty labelId={labelId} label="Remind me before" value={value}
      renderValue={reminderSummary} sx={{ fontSize: '0.8125rem' }}
      onChange={event => {
        const selected = event.target.value;
        onChange(selected.includes('off') ? [] : selected.map(Number).sort((a,b) => b-a));
      }}>
      <MenuItem value="off"><ListItemText primary="Turn off reminders" primaryTypographyProps={{ fontSize: '0.8125rem' }} /></MenuItem>
      {REMINDER_DAY_OPTIONS.map(day => <MenuItem key={day} value={day}>
        <Checkbox size="small" checked={value.includes(day)} />
        <ListItemText primary={day === 0 ? 'On expiry date' : `${day} day${day === 1 ? '' : 's'} before`} primaryTypographyProps={{ fontSize: '0.8125rem' }} />
      </MenuItem>)}
    </Select>
    <FormHelperText>Choose multiple reminders, or turn them off. An expiry date is required.</FormHelperText>
  </FormControl>;
}
